import { useEffect, useRef, useState } from "react";

const AddressAutocomplete = ({
  label,
  placeholder,
  helpIcon,
  value,
  onChange,
  onAddressSelect,
}) => {
  const autocompleteInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (window.google && autocompleteInputRef.current) {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        autocompleteInputRef.current,
        {
          types: ["geocode"],
          componentRestrictions: { country: "uk" },
          fields: ["address_components", "formatted_address"],
        }
      );

      autocompleteRef.current.addListener("place_changed", () => {
        const place = autocompleteRef.current.getPlace();
        if (place.address_components) {
          onAddressSelect(place.address_components, place.formatted_address);
        }
      });
    }

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [onAddressSelect]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

        .aac-wrap {
          display: flex; flex-direction: column; gap: 6px;
          width: 100%; font-family: 'DM Sans', sans-serif;
        }

        .aac-label-row { display: flex; align-items: center; gap: 6px; }

        .aac-label { font-size: 12px; font-weight: 600; color: #475569; }

        .aac-input {
          width: 100%;
          padding: 9px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; color: #0F172A;
          background: #ffffff;
          border: 1px solid #E2E8F0; border-radius: 10px;
          outline: none;
          box-shadow: 0 1px 2px rgba(0,0,0,0.04);
          transition: border-color 0.15s, box-shadow 0.15s;
        }

        .aac-input::placeholder { color: #94A3B8; }

        .aac-input:focus {
          border-color: #2563EB;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }

        /* Google autocomplete dropdown styling */
        .pac-container {
          font-family: 'DM Sans', sans-serif !important;
          border: 1px solid #E2E8F0 !important;
          border-radius: 10px !important;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1) !important;
          margin-top: 4px !important;
          padding: 4px !important;
          overflow: hidden;
        }

        .pac-item {
          font-family: 'DM Sans', sans-serif !important;
          font-size: 13px !important;
          color: #1E293B !important;
          padding: 9px 12px !important;
          border-radius: 7px !important;
          border-top: none !important;
          cursor: pointer !important;
          transition: background 0.12s !important;
        }

        .pac-item:hover { background: #F1F5F9 !important; }

        .pac-item-selected { background: #EFF6FF !important; }

        .pac-item-query {
          font-family: 'DM Sans', sans-serif !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #0F172A !important;
        }

        .pac-matched { color: #2563EB !important; font-weight: 700 !important; }

        .pac-icon { display: none !important; }

        .pac-logo::after { display: none !important; }
      `}</style>

      <div className="aac-wrap">
        <div className="aac-label-row">
          <label className="aac-label">{label}</label>
          {/* help icon intentionally omitted — was a broken img with no fallback */}
        </div>

        <input
          className="aac-input"
          type="text"
          placeholder={placeholder}
          ref={autocompleteInputRef}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </div>
    </>
  );
};

export default AddressAutocomplete;